<template>
	<div>
		<el-card shadow="never">
			<el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
				<el-form-item label="课程名称：">
					<el-input v-model="dataForm.name" placeholder="请输入" clearable suffix-icon="el-icon-search">
					</el-input>
				</el-form-item>
				<el-form-item label="一级分类：">
					<el-select @change="changeFirstType" v-model="dataForm.course_cate_uuid" placeholder="请选择">
						<el-option v-for="item in level" :key="item.uuid" :label="item.name" :value="item.uuid">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="二级分类：">
					<!-- <el-cascader v-model="selectedOptions" @change="changeType" :options="levelChild"
						clearable></el-cascader> -->
					<el-select v-model="dataForm.sub_course_cate_uuid" placeholder="请选择">
						<el-option v-for="item in levelChild" :key="item.uuid" :label="item.name" :value="item.uuid">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="课程状态：">
					<el-select v-model="dataForm.vis" placeholder="请选择">
						<el-option v-for="item in userStatuList" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="network().getUserTableList()">搜索</el-button>
					<el-button @click="event().clearSearch()">重置</el-button>
				</el-form-item>
				<!-- <el-form-item style="float: right;">
			    <el-button type="primary" @click="network().downloadUserTableExcel()">导出</el-button>
			  </el-form-item> -->
			</el-form>
		</el-card>
		<el-card shadow="never" style="margin-top: 30px;">
			<el-form :inline='true'>
				<el-form-item>
					<el-button type="primary" @click="addAdminClick('新增')"> 新增课程
					</el-button>
				</el-form-item>
				<!-- <el-form-item>
					<el-button type="primary" @click="downLoadTemp">下载模板
					</el-button>
				</el-form-item> -->
			</el-form>
			<el-table row-key="id" :data="tableData" border class="table-wrap"
				:header-cell-style="{background:'#eef1f6',color:'#606266'}" @selection-change="handleChange">
				<el-table-column prop="uuid" label="课程ID" align="center">
				</el-table-column>
				<el-table-column prop="name" label="课程名称" fit align="center">
				</el-table-column>
				<el-table-column prop="course_cate_name" label="课程分类" fit align="center">
					<template slot-scope="scope">
						{{scope.row.course_cate_name}} <span style="margin: 0 2px;">/</span>
						{{scope.row.sub_course_cate_name}}
					</template>
				</el-table-column>
				<el-table-column prop="num" label="课程章节数" fit align="center">
				</el-table-column>
				<el-table-column prop="weight" label="课程权重" fit align="center">
				</el-table-column>
				<el-table-column prop="vis" label="课程状态" fit align="center">
					<template slot-scope="scope">
						{{scope.row.vis==1?'上架':'下架'}}
					</template>
				</el-table-column>
				<el-table-column prop="create_time" label="创建时间" fit align="center">
				</el-table-column>
				<el-table-column label="操作" width="300px" align="center" fit>
					<template slot-scope="scope">
						<div class="operation-wrap">
							<span class="operation-item" @click="event().handleOperationClick(scope.row)">查看</span>
							<span class="operation-item" v-if="scope.row.vis == 2"
								@click="editAdminClick(scope.row)">编辑</span>
							<span class="operation-item" style="color: #ff0000;" v-if="scope.row.vis == 1"
								@click="updateCourseVisClick(scope.row,2,'下架')">下架</span>
							<span class="operation-item" v-if="scope.row.vis == 2"
								@click="updateCourseVisClick(scope.row,1,'上架')">上架</span>
							<span class="operation-item delete" @click="deleteClick(scope.row)">
								删除</span>
						</div>
					</template>
				</el-table-column>
			</el-table>

			<common-dialog :titleType="titleType" :title="dialogTitle" :dialogVisible="dialogVisible"
				@cancel="dialogCancelClick" @confirm="dialogConfirmClick" @dialog-close="dialogClose">
				<div class="dialog-body-wrap">
					<div v-if="titleType ==='删除'">
						<span style="color: #ff0000;">课程删除后，已购此课程的用户将显示课程已下架，无法进行继续学习</span>
					</div>
					<div v-if="titleType ==='下架'">
						<span style="color: #ff0000;">下架后，用户端将不再进行展示且已购买的用户将无法进行学习</span>
					</div>
				</div>
			</common-dialog>


			<common-pagination :total="total" :page_size="page_size" :page_index="page_index"
				@page-change="handlePageChange" @size-change="handleSizeChange"></common-pagination>

			<CourseTypeDialog :uuid="selectForm" :dialogProp="editdialogVisible" @input="closeDialog"
				@confirm="confirmDialog">
			</CourseTypeDialog>
		</el-card>
	</div>
</template>

<script>
	import CommonDialog from "@/components/CommonDialog";
	import operations from "@/mixins/operations";
	import CourseTypeDialog from "./components/CourseTypeDialog.vue"
	import CommonPagination from "@/components/CommonPagination";
	import {
		getCourseCateList,
		getCourseList,
		deleteCourse,
		updateCourseVis
	} from "@/api/course"
	import {
		mapState
	} from "vuex";
	import utils from "@/jslibs/utils"

	export default {
		name: "hotellist",
		mixins: [operations],
		data() {
			return {
				selectedOptions: [],
				titleType: '删除',
				total: 0,
				page_size: 10,
				page_index: 1,
				tableData: [],
				selectedTabIndex: "1",
				dataForm: {
					course_cate_uuid: "",
					vis: '',
					name: '',
					sub_course_cate_uuid: ''
				},
				showDialog: false,
				showDialogType: "Authentication",
				showDialogTitle: '',
				cancelBtnText: "",
				userAuthInfo: {},
				level: [],
				levelChild: [],
				userStatuList: [{
					value: 1,
					label: '上架'
				}, {
					value: 2,
					label: '下架'
				}],
				allChioce: [],
				allSelectIdList: [],
				selectForm: {},
				editdialogVisible: false,
				//删除弹框开始
				dialogTitle: "",
				dialogType: "",
				dialogVisible: false,
				form: {},
				//删除弹框结束
				passwordShow: false,
				passwordForm: {}
			};
		},
		components: {
			CommonPagination,
			CourseTypeDialog,
			CommonDialog
		},
		mounted() {
			this.getTypes()
			this.getSubsTypes()
			this.network().getUserTableList();
		},
		computed: {
			...mapState(["imgDomain"])
		},
		methods: {
			changeFirstType(e) {
				this.getSubsTypes(e)
			},
			async getTypes() {
				const {
					status,
					data
				} = await getCourseCateList({
					page_index: 1,
					page_size: 9999,
					level: 1,
					pid:''
				});
				if (status !== 200) return;
				let arrs = data.result.data;
				this.level = arrs
			},
			async getSubsTypes(e) {
				const {
					status,
					data
				} = await getCourseCateList({
					page_index: 1,
					page_size: 9999,
					level: 2,
					pid: e
				});
				if (status !== 200) return;
				let arrs = data.result.data;
				this.levelChild = arrs
			},
			downLoadTemp() {
				window.location.href =
					'https://gymoo-project-cdn.oss-cn-shenzhen.aliyuncs.com/innovation/%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
			},
			resetPasswordClick(row) {
				this.passwordShow = true;
				this.passwordForm = row;
			},
			async updateCourseVisClick(item, vis, titleType) {
				this.titleType = titleType
				this.form = JSON.parse(JSON.stringify(item));
				this.dialogVisible = true;
				this.dialogType = "update";
				this.dialogTitle = "当前课程吗？";
				// const {
				// 	status
				// } = await updateCourseVis({
				// 	id: item.uuid,
				// 	is_disable: is_disable
				// });
				// this.$message.success('操作成功')
				// if (status === 200) {
				// 	this.network().getUserTableList();
				// }
			},
			//删除弹框开始
			dialogCancelClick: () => {
				this.dialogVisible = false
			},
			async dialogConfirmClick() {
				if (this.dialogType === "delete") {
					let postData = {
						uuid: this.form.uuid
					}
					const {
						status
					} = await deleteCourse(postData);
					this.$message.success('删除成功')
					if (status === 200) {
						this.dialogVisible = false;
						return;
					}
				}
				if (this.dialogType === "update") {
					let postData = {
						uuid: this.form.uuid,
						vis: this.form.vis == 1 ? 2 : 1
					}
					const {
						status
					} = await updateCourseVis(postData);
					this.$message.success('更新成功')
					if (status === 200) {
						this.dialogVisible = false;
						return;
					}
				}
			},
			dialogClose() {
				this.dialogVisible = false;
				this.network().getUserTableList();
			},
			deleteClick(row) {
				this.form = JSON.parse(JSON.stringify(row));
				this.dialogVisible = true;
				this.dialogType = "delete";
				this.titleType = '删除'
				this.dialogTitle = "当前课程吗？";
			},
			//删除弹框结束
			closeDialog(row) {
				this.passwordShow = false
				this.editdialogVisible = false;
			},
			confirmDialog(row) {
				this.editdialogVisible = row;
				this.network().getUserTableList()
			},
			//添加
			addAdminClick() {
				this.selectForm = {};
				this.selectForm.role_uuid = this.uuid
				this.editdialogVisible = true;
				this.$router.push({
					path: '/course-list-dialog'
				})
			},
			//修改
			editAdminClick(row) {
				// this.editdialogVisible = true;
				// this.selectForm = row;
				// this.selectForm.role_uuid = this.uuid
				this.$router.push({
					path: '/course-list-dialog?uuid=' + row.uuid
				})
			},
			handleChange(row) {
				this.allSelectIdList = row.map(item => item.user_id);
			},
			tabChange(e) {
				this.dataForm.status = e
				this.network().getUserTableList();
			},
			/**文件上传选择完成时触发的事件函数**/
			onFileChange(e) {
				let file = e.target.file[0]
			},
			handlePageChange(page) {
				this.event().handlePageChange(page);
			},
			handleSizeChange(size) {
				this.event().handleSizeChange(size);
			},
			/**
			 *触摸，响应事件放在event下，如onclick函数,onchange函数等
			 *特殊情况:像一些需要接收参数的事件，如onchange原生事件或者是vue中的emit有参数的事件,必须得写在event外部，否则无法得到接收参数。像这种事件特殊处理
			 **/
			event() {
				return {
					clearSearch: () => {
						this.dataForm.name = ''
						this.dataForm.vis = ''
						this.dataForm.course_cate_uuid = ''
						this.dataForm.sub_course_cate_uuid = ''
						this.page_index = 1
						this.selectedOptions = []
						this.network().getUserTableList();
					},
					handleClick: () => {
						this.network().getUserTableList();
					},
					toggleTab: (index) => {
						this.allChioce = [];
						this.dataForm.is_blacklist = index
						this.network().getUserTableList();
					},
					/**
					 * 点击全选
					 * @param {Object} index
					 */
					onAllChioceChange: (row) => {
						//全选将List中的id提取出来
						this.allSelectIdList = row.map(item => item.user_id);
					},
					/**
					 * 已认证用户点击
					 */
					onShowDialogClick: (btn, data) => {
						this.showDialog = true;
						this.showDialogType = btn;
						this.userAuthInfo = data;
						this.showDialogTitle = '认证信息';
						this.cancelBtnText = "返回"
					},
					onCloseModalClick: () => {
						this.showDialog = false;
					},
					/**
					 * 查看用户详情
					 */
					handleOperationClick: (data) => {
						this.$router.push({
							path: "/course-detail?uuid=" + data.uuid
						})
					},
					/**
					 * 解禁/禁用
					 * @param {Object} uuid
					 */
					handleIsDisableclick: (uuid, is_blacklist) => {
						// var uuidList = uuid.split(",");
						this.network().newWorkIsDisableClick(uuid, is_blacklist);
					},
					handlePageChange: (page) => {
						this.page_index = page;
						this.network().getUserTableList();
					},
					handleSizeChange: (size) => {
						this.page_size = size;
						this.network().getUserTableList();
					},
					onBatchApprovalClick: (isDisable) => {
						if (this.allSelectIdList.length > 0) {
							if (isDisable) { // true 解
								this.network().batchUnDisable()
							} else {
								this.network().batchDisable()
							}
						} else {
							this.$message.error('请点击全选选项');
						}
					},
				}
			},
			/**
			 *网络访问相关函数
			 **/
			network() {
				return {
					getUserTableList: async () => {

						let postData = {
							page_size: this.page_size,
							page_index: this.page_index,
							name: this.dataForm.name,
							course_cate_uuid: this.dataForm.course_cate_uuid,
							sub_course_cate_uuid: this.dataForm.sub_course_cate_uuid,
							vis: this.dataForm.vis
						};
						const {
							status,
							data
						} = await getCourseList(postData);
						if (status !== 200) return;
						this.tableData = data.result.data;
						this.total = data.result.total;
					},

					batchDisable: async () => {
						let postData = {
							user_ids: this.allSelectIdList
						}
						const {
							status,
							data
						} = await batchDisable(postData);
						if (status !== 200) return;
						this.network().getUserTableList();
					},
					batchUnDisable: async () => {
						let postData = {
							user_ids: this.allSelectIdList
						}
						const {
							status,
							data
						} = await batchUnDisable(postData);
						if (status !== 200) return;
						this.network().getUserTableList();
					},


					disableUser: async (row) => {
						let postData = {
							user_id: row.user_id
						}
						const {
							status,
							data
						} = await disableUser(postData);
						if (status !== 200) return;
						this.network().getUserTableList();
					},

					ableUser: async (row) => {
						let postData = {
							user_id: row.user_id
						}
						const {
							status,
							data
						} = await ableUser(postData);
						if (status !== 200) return;
						this.network().getUserTableList();
					},
				}
			},
			/**
			 * 一般放处理业务逻辑较多的私人函数
			 **/
			handler() {
				return {
					handleListA(list) {
						for (var i = 0; i < list.length; i++) {
							//handle service
						}
					},
					/**
					 **校验表单输入
					 **/
					verifyInput() {},

				}
			}

		}
	};
</script>

<style lang="less" scoped>
	@import "~@/assets/styles/variables.less";
	@import "~@/assets/styles/mixins.less";

	.table-wrap {
		.table-wrap(5px);
	}

	.m-content {
		width: 12rem;
	}

	.m-tab {
		position: relative;
		margin-bottom: 2.1875rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.m-tab-item {
		padding-right: 2.0625rem;
		color: #8D8EA6;
		font-size: 1.375rem;
		text-align: center;
	}

	.m-tab-item-active {
		color: #409eff;
	}

	.tab-line {
		height: 2px;
		background: #409eff;
		position: absolute;
		bottom: 0;
		transition: all 0.3s ease;
	}

	.tab-line-0 {
		width: 3rem;
		left: 0;
	}

	.tab-line-1 {
		width: 5rem;
		left: 1;
	}
</style>